import { ClientSubscriptionViewModel } from '@common/model/billing/clientSubscription';
import { DateISOString } from '@common/types';

export const isActive = (subscription: ClientSubscriptionViewModel, now: DateISOString = new Date().toISOString()): boolean => {
  const stared = Boolean(subscription.validFrom && subscription.validFrom < now);
  const expired = Boolean(subscription.expiredAt && subscription.expiredAt < now);
  return stared && !expired;
};
